import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import CaseSearchPanel from './CaseSearchPanel';

export default function QuickCaseSearchDialog({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-[70]">
      <DialogBackdrop className="fixed inset-0 bg-gray-900/60" />
      <div className="fixed inset-0 overflow-y-auto p-4 sm:p-8">
        <div className="flex min-h-full items-start justify-center sm:items-center">
          <DialogPanel className="w-full max-w-4xl overflow-hidden rounded-2xl bg-gray-50 shadow-2xl">
            <div className="flex items-center justify-between border-b border-gray-200 bg-white px-5 py-4 sm:px-6">
              <div className="flex items-center gap-3">
                <span className="rounded-lg bg-indigo-100 p-2 text-indigo-700">
                  <MagnifyingGlassIcon className="h-5 w-5" aria-hidden="true" />
                </span>
                <div>
                  <h2 className="font-semibold text-gray-900">Quick Case Search</h2>
                  <p className="text-sm text-gray-500">Open another active or archived case.</p>
                </div>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-700"
                aria-label="Close quick case search"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            <div className="p-5 sm:p-6">
              <CaseSearchPanel autoFocus onCaseSelected={onClose} />
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
